// React
import React from "react";

// React Router
import { Link } from 'react-router-dom';

// Components
import { Footer } from '../../Components';

// Styles
import './beta.css';
import './ourstory.css';

export const OurStory = () => {

    return (
        <React.Fragment>
        <div id='Beta'>
            <div className='beta-logo'>
                <img src="./assets/img/logo.svg" alt='Yety Logo'/>               
            </div>
            <div className='beta-header'>
                Our Story          
            </div>
            <div className='team-profiles'>

                <div className='profile'>
                    <div className='member-column'>
                        <img className='portrait' src="./assets/img/team/th.jpg" alt='Thomas Herren'/>  
                        <div className='member-title'>Founder</div>
                    </div>
                    <div className='member-column'>
                        <div className='member-name'>Tom Herren</div>
                        <div className='member-role'>{'Head of Product Design & Platform Architecture'}</div>
                    </div>
                </div>

                <div className='profile'>
                    <div className='member-column'>
                        <div className='portrait'></div>
                        <div className='member-title'>Founder</div>
                    </div>
                    <div className='member-column'>
                        <div className='member-name'>Dinusha Lokuliyana</div>
                        <div className='member-role'>{'Head of Financial Engineering & Big Data Analytics'}</div>
                    </div>
                </div>

                <div className='profile'>
                    <div className='member-column'>
                        <div className='portrait'></div>
                        <div className='member-title'>Founder</div>
                    </div>
                    <div className='member-column'>
                        <div className='member-name'>Gabriela Henriques</div>
                        <div className='member-role'>{'Head of Infrastructure Architecture, Cloud & DevOps'}</div>
                    </div>
                </div>

                <div className='profile'>
                    <div className='member-column'>
                        <div className='portrait'></div>
                        <div className='member-title'>Engineer</div>
                    </div>
                    <div className='member-column'>
                        <div className='member-name'>Nicholas Hawkes</div>
                        <div className='member-role'>{'Infrastructure Architecture & DevOps Specialist'}</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </React.Fragment>
    );

};

export default OurStory;


// WEBPACK FOOTER //
// ./src/Views/InfoPages/OurStory.js